import { Component, OnInit } from "@angular/core";
import { PropertyService } from "app/services/property.service";

@Component({
  selector: "app-buildings",
  templateUrl: "./buildings.component.html",
  styleUrls: ["./buildings.component.scss"],
})
export class BuildingsComponent  implements OnInit {

  loading = true;
  propertyList: any[] = [];

  constructor(
      private readonly propertyService: PropertyService
  ) {
  }

  ngOnInit() {
      this.propertyService.getProperties().then((res) => {
          this.propertyList = res;
      }).finally(() => {
          this.loading = false;
      });
  }
}